const analyticsConfig = {
  api: {
    baseUrl: 'https://service9006.szapfs.org',
    endpoints: {
      login: '/auth/login',
      query: '/analytics/query'
    }
  }
};

export function getApiBaseUrl() {
  return analyticsConfig.api.baseUrl;
}

export function getApiEndpoint(endpoint) {
  const baseUrl = analyticsConfig.api.baseUrl;
  const path = analyticsConfig.api.endpoints[endpoint];
  if (!path) {
    console.error(`API endpoint "${endpoint}" is not defined in analytics config.js`);
    return null;
  }
  return `${baseUrl}${path}`;
}

export default analyticsConfig;
